





























































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { Prop, Watch } from 'vue-property-decorator';
import jsEncrypt from '@/shared/jsEncrypt';
import { InfoState } from '@/core';

const cssPrefix = 'update-address';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
  },
})
export default class UpdatePassword extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  displayUpdatePassword : any;
  isSubmitted : boolean = false;
  currentPassword : string = '';
  newPassword : string = '';
  cnfNewPassword : string = '';
  isEntered: boolean = true;
  strength: string = '';
  colors = ['#F00', '#F90', '#009940', '#009940'];
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  bar4: string;
  @Watch('newPassword')
  onValueChange(val: string) {
    this.newPassword = val;
    this.setBarColors(5, '#DDD');
    if (this.newPassword.trim().length > 0) {
      let passedMatches = 0;
      const lowerLetters = /.*?[a-z].*[a-z]/.test(this.newPassword);
      const upperLetters = /.*?[A-Z].*[A-Z]/.test(this.newPassword);
      const numbers = /.*?[0-9].*[0-9]/.test(this.newPassword);
      const symbols = /.*?[$@/:-?{-~!"^_`\[\]-].*[$@/:-?{-~!"^_`\[\]-]/.test(this.newPassword);
      let idx = 0;
      const flags = [lowerLetters, upperLetters, numbers, symbols];
      this.strength = '';

      for (const flag of flags) {
        passedMatches += flag ? 1 : 0;
      }
      if (this.newPassword.length >= 10 && passedMatches === 4) {
        idx = 3;
        this.strength = 'Strong';
      } else if (this.newPassword.length >= 8 && passedMatches >= 2) {
        idx = 2;
        this.strength = 'Average';
      } else if (this.newPassword.length >= 6 && passedMatches >= 1) {
        idx = 1;
        this.strength = 'Weak';
      } else {
        idx = 0;
        this.strength = 'Poor';
      }
      console.warn(idx);
      console.warn(this.strength);
      console.warn(this.newPassword);
      this.setBarColors(idx + 1, this.colors[idx]);
    }
  }
  created() {
  }
  closeDialog() {
    this.$emit('close-modal');
  }
  submit() {
    this.isSubmitted = true;
    if (this.isValidate()) {
      const request = {
        currentPassword: jsEncrypt.getEncryptObj_msw()
                    .encrypt(this.currentPassword.trim()),
        newPassword : jsEncrypt.getEncryptObj_msw()
                    .encrypt(this.newPassword.trim()),
      };
      const store = (this as any).$store;
      const emit = (this as any).$emit.bind(this);
      const t = (this as any).$t.bind(this);
      const fallbackMsg = t('systemMessages.APIFailure').toString();
      const successMsg = t('profile.updatePwdSuccess').toString();
      store.dispatch('SnbProfileStoreModule/updatePassword', request)
      .then((response : any) => {
        store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          const message : InfoState = { infoType : 'success', infoMsg : response.msgDesc || successMsg };
          store.commit('enqueueMessage', message);
          emit('close-modal', message);
        } else {
          const message : InfoState = { infoType : 'failed', infoMsg : (response != null ? response.msgDesc : null) || fallbackMsg };
          store.commit('enqueueMessage', message);
          emit('show-message', message);
        }
      })
      .catch(() => {
        store.commit('stopLoading');
        const message : InfoState = { infoType: 'failed', infoMsg: fallbackMsg };
        store.commit('enqueueMessage', message);
        emit('show-message', message);
      });
    }
  }
  get showPwdRuleMsg(): boolean {
    return (this.isEntered || (!this.isEntered && this.newPassword !== '' && !this.isPasswordValid) || (this.isSubmitted && this.newPassword === ''))
      && (this.newPassword === '' || this.strength === '');
  }

  get pwdRuleHasError(): boolean {
    return (!this.isEntered && this.newPassword !== '' && !this.isPasswordValid) || (this.isSubmitted && this.newPassword === '');
  }

  get isPasswordValid(): boolean {
    const pwd = this.newPassword;
    if (pwd.length < 8) { return false; }
    const hasLower = (pwd.match(/[a-z]/g) || []).length >= 2;
    const hasUpper = (pwd.match(/[A-Z]/g) || []).length >= 2;
    const hasNumbers = (pwd.match(/[0-9]/g) || []).length >= 2;
    const hasSymbol = (pwd.match(/[$@/:-?{-~!"^_`\[\]\-]/g) || []).length >= 1;
    return hasLower && hasUpper && hasNumbers && hasSymbol;
  }
  isValidate() {
    let validateFlag = true;
    if (this.currentPassword.trim().length === 0 || this.newPassword.trim().length === 0 || this.cnfNewPassword.trim().length === 0) {
      validateFlag = false;
    }
    if (this.newPassword.trim() !== this.cnfNewPassword.trim()) {
      validateFlag = false;
    }
    return validateFlag;
  }
  setBarColors(count : any, col : any) {
    for (let n = 0; n < count; n += 1) {
      switch (n) {
        case 0:
          this.bar0 = col;
          break;
        case 1:
          this.bar1 = col;
          break;
        case 2:
          this.bar2 = col;
          break;
        case 3:
          this.bar3 = col;
          break;
        case 4:
          this.bar4 = col;
          break;
      }
    }
  }
}
